import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../Redux/Constants/GlobalConstant";

const VendorContext = createContext();

export const VendorProvider = ({ children }) => {
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // const domain = window.location.host.replace("www.", "");

    axios
      .get(BASE_URL + `/api/superadmin/vendor-by-domain`)
      .then((res) => {
        setVendor(res.data);
        console.log("vendor", res.data);
      })
      .catch((err) => {
        console.error("Vendor Load Failed:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <VendorContext.Provider value={{ vendor, loading }}>
      {children}
    </VendorContext.Provider>
  );
};

export const useVendor = () => useContext(VendorContext);